import { TagType } from '../../../../common/model/input/products/types';
import { bouComparisonColors } from './bou-colors';

// OA: Legacy from 2018. NEVER use this for anything new. Use BouColor.
export const colors = {
  // teatteri design colors
  black: (alpha = 1) => `rgba(17, 17, 17, ${alpha})`,
  grayLightest: (alpha = 1) => `rgba(238, 238, 238, ${alpha})`,
  grayLight: (alpha = 1) => `rgba(192, 192, 192, ${alpha})`,
  grayWarm: (alpha = 1) => `rgba(153, 153, 153, ${alpha})`,
  whiteTwo: (alpha = 1) => `rgba(250, 250, 250, ${alpha})`,
  redError: (alpha = 1) => `rgba(208, 2, 27, ${alpha})`,
  white: (alpha = 1) => `rgba(255, 255, 255, ${alpha})`,

  darkViolet: (alpha = 1) => `rgba(55, 55, 100, ${alpha})`,
  mint: (alpha = 1) => `rgba(64, 193, 172, ${alpha})`,
  gray,
  apricose: (alpha = 1) => `rgba(255, 190, 159, ${alpha})`,
  sand: (alpha = 1) => `rgba(248, 229, 154, ${alpha})`,
  // lila: (alpha = 1) => `rgba(139, 132, 215, ${alpha})`,
  // bodyTextColor: (alpha = 1) => `rgba(51, 51, 51, ${alpha})`,
  blueLight: (alpha = 1) => `rgba(199, 219, 249, ${alpha})`,

  // upright colors
  pink: (alpha = 1) => `rgba(255, 66, 213, ${alpha})`,
  pinkHover: (alpha = 1) => `rgba(211, 55, 176, ${alpha})`,
  pinkDark: (alpha = 1) => `rgba(153, 40, 128, ${alpha})`,
  lemon: (alpha = 1) => `rgba(255, 255, 34, ${alpha})`,

  cyan: (alpha = 1) => `rgba(68, 204, 255, ${alpha})`,
  tangerine: (alpha = 1) => `rgba(255, 217, 91, ${alpha})`,
  green: (alpha = 1) => `rgba(51, 221, 85, ${alpha})`,
  purple: (alpha = 1) => `rgba(68, 0, 102, ${alpha})`,
  purpleLight: (alpha = 1) => `rgba(223, 181, 255, ${alpha})`,

  // from colorbrewer
  red: (alpha = 1) => `rgba(196, 23, 28, ${alpha})`,
};

export function tagTypeColor(tagType: TagType, alpha?: number) {
  switch (tagType) {
    case TagType.CRITICAL:
    case TagType.DOWNSTREAM:
    case TagType.ENABLED_BY:
    case TagType.ENABLES:
      return colors.tangerine(alpha || 0.9);
    case TagType.UPSTREAM:
      return colors.purpleLight(alpha || 0.9);
    case TagType.BLACKLIST:
      return colors.darkViolet(alpha || 0.9);
  }
}

export const phraseColor = colors.blueLight();

const seriesColors = bouComparisonColors;

export function seriesColorScale(index: number) {
  return seriesColors[index % seriesColors.length];
}

export function gray(step: number, alpha = 1) {
  const value = Math.round(242 - (step * (242 - 51)) / 5);
  return `rgba(${value}, ${value}, ${value}, ${alpha})`;
}
